






































































































import Vue from 'vue';
import draggable from 'vuedraggable';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import StructureDto = DisguiseDto.StructureDto;

@Component({
  components: {
    draggable
  },
  name: 'DraggableTreeNode'
})
export default class DraggableTreeView extends Vue {
  @Prop() level!: number;
  @Prop() root!: boolean;
  @Prop() group!: string;
  @Prop({
    default: (): DisguiseDto.StructureDto<any> => {
      return {
        '@type': 'StructureDto',
        'children': [],
        'id': 0,
        'name': ''
      };
    }
  }) value!: DisguiseDto.StructureDto<any>;
  @Prop({
    default: null
  }) selectedItem!: DisguiseDto.StructureDto<any> | null;

  open: boolean = false;
  hover: boolean = false;
  localValue: DisguiseDto.StructureDto<any> | undefined;
  dummyChild: DisguiseDto.StructureDto<any> = {
    'isLeaf': true,
    'id': -1,
    'actions': [],
    'depth': this.level + 1,
    '@type': 'StructureDto'
  };

  @Watch('value') valueChanged(
      newValue: DisguiseDto.StructureDto<any>
  ) {
    this.localValue = {...newValue};
  }

  created() {
    this.localValue = {...this.value};
  }

  toggleOpenState($event: Event) {
    this.open = !this.open;
    $event.stopPropagation();
  }

  appendLevel(): number {
    return this.level + (this.localValue?.isLeaf ? 1 : 0);
  }

  updateValue(
      newValue: Array<DisguiseDto.StructureDto<any>>
  ): void {
    if (this.localValue) {
      this.localValue.children = [...newValue];
      this.$emit('input', this.localValue);
    }
  }

  updateChildValue(
      newValue: DisguiseDto.StructureDto<any>
  ): void {
    if (this.localValue && this.localValue.children) {
      const index = this.localValue.children.findIndex(
          (c) => c.id === newValue.id
      );
      this.$set(this.localValue.children, index, newValue);
    }
    this.$emit('input', this.localValue);
  }

  selectItem(): void {
    if (this.localValue === this.selectedItem) {
      this.$emit('selected', null);
    } else {
      this.$emit('selected', this.localValue);
    }
  }

  selectChildItem(
      newItem: DisguiseDto.StructureDto<any>
  ): void {
    this.$emit('selected', newItem);
  }

  moveUp(
      movedItem: DisguiseDto.StructureDto<any>
  ) {
    this.$emit('childmoveup', movedItem);
  }

  moveDown(
      movedItem: DisguiseDto.StructureDto<any>
  ) {
    this.$emit('childmovedown', movedItem);
  }

  deleteItem(
      movedItem: DisguiseDto.StructureDto<any>
  ) {
    this.$emit('childdelete', movedItem);
  }

  onChildMoveUp(movedItem: DisguiseDto.StructureDto<any>) {
    if (this.localValue && this.localValue.children) {
      const index = this.localValue.children.findIndex(
          (c) => c.id === movedItem.id
      );
      if (index !== 0) {
        this.localValue.children = this.localValue.children.map((element, i) => {
          // iterate array and change places
          if (i === index - 1) {
            return (this.localValue?.children || [])[index];
          } else if (i === index) {
            return (this.localValue?.children || [])[index - 1];
          } else {
            return element;
          }
        });
      }
    }
    this.$emit('input', this.localValue);
  }

  onChildMoveDown(movedItem: DisguiseDto.StructureDto<any>) {
    if (this.localValue && this.localValue.children) {
      const index = this.localValue.children.findIndex(
          (c) => c.id === movedItem.id
      );
      if (index < this.localValue.children.length) {
        this.localValue.children = this.localValue.children.map((element, i) => {
          // iterate array and change places
          if (i === index) {
            return (this.localValue?.children || [])[index + 1];
          } else if (i === index + 1) {
            return (this.localValue?.children || [])[index];
          } else {
            return element;
          }
        });
      }
    }
    this.$emit('input', this.localValue);
  }

  onChildDelete(movedItem: DisguiseDto.StructureDto<any>) {
    if (this.localValue && this.localValue.children) {
      const index = this.localValue.children.findIndex(
          (c) => c.id === movedItem.id
      );
      if (index >= 0) {
        this.localValue.children.splice(index, 1);
      }
    }
    this.$emit('input', this.localValue);
  }
}
